import styled from 'styled-components';

export const TitleWrapper = styled.div`
  ${(p) => p.theme.typography.subHeader};
  color: ${(p) => p.theme.colors.text};
  margin-top: 12px;
  margin-bottom: 4px;
`;

export const ContentWrapper = styled.div`
  ${(p) => p.theme.typography.description};
  color: ${(p) => p.theme.colors.muted};
`;

export const Wrapper = styled.div`
  box-shadow: 0 1px 4px rgba(0, 36, 77, 0.08);
  border-radius: 8px;
  padding: 16px 24px;
  height: 100%;
  box-sizing: border-box;
`;
